export const TextColor = '#222';
export const AccentHlColor = '#0265DC';
export const ColorDark = '#E6E6E6';
export const BrandingHlColor = '#FFBB63';
export const DesignHlColor = '#BD8BFC';
export const EngineeringHlColor = '#59A7F6';